import React from 'react';

const withReviewSkoob = (Component: any) => (props: any) => {
  const skoobProps = {
    ...props,
    review: {
      ...props.review,
      title: props.review?.title || props.productName,
    },
    owner: {
      ...props?.owner,
    },
    isSkoob: props?.badges?.includes('skoob'),
  };

  return <Component {...skoobProps} />;
};

export default withReviewSkoob;
export { withReviewSkoob };
